const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://aahpichardo.vercel.app/',
  title: 'A A.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Angel Pichardo',
  role: 'Junior Software Developer',
  description:
    'With an insatiable desire to learn and create innovative technology.',
  resume: 'https://drive.google.com/file/d/1GHKBBkyIDuHKzwREwhfdro-sHFUO_cck/view?usp=sharing',
  social: {
    linkedin: 'https://www.linkedin.com/in/aahp/',
    github: 'https://github.com/aahpichardo',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'PickItUp!',
    description:
      'Service in the form of a website dedicated to restaurants as a letter of introduction with the possibility of placing an order, keeping a record of them, it includes a login and user registration.',
    stack: ['HTML', 'CSS', 'JavaScript', 'Bootstrap', 'PHP', 'MySQL'],
    sourceCode: 'https://github.com/aahpichardo',
    livePreview: 'https://github.com/aahpichardo',
  },
  {
    name: 'TechBox',
    description:
      'IoT vending machine for loans of material with connection to a mobile application, cloud database and a website',
    stack: ['React', 'TailWindCSS', 'JavaScript', 'React Native', 'Firebase', 'C++' ],
    sourceCode: 'https://github.com/aahpichardo/techbox-microcontrolador',
    livePreview: 'https://github.com/julioerives/techBox',
  },
  {
    name: 'pLibrary',
    description:
      'Website for a library. Allows users to view information about the library, register for an account, contact the library, and view a catalog of books.',
    stack: ['HTML', 'CSS', 'JavaScript', 'Bootstrap', 'Firebase', 'Various APIs'],
    sourceCode: 'https://github.com/aahpichardo/pLibrary',
    livePreview: 'https://p-library.vercel.app/',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'HTML',
  'CSS',
  'JavaScript',
  'Java OOP',
  'React',
  'SQL and NoSQL databases',
  'Git',
  'C++'
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'aahpichardo@gmail.com',
}

export { header, about, projects, skills, contact }
